import React, { FC } from 'react'
import { Image } from '@/atoms/Image'

interface Props {
  imageUrl: string
}

export const BackgroundBlurImage: FC<Props> = ({ imageUrl }) => {
  return (
    <>
      <div className="absolute h-full w-full overflow-hidden">
        <Image
          priority
          className="absolute inset-0 block scale-150 blur-xl"
          alt=""
          quality={10}
          src={imageUrl}
          fill
          sizes="(max-width: 1023px) 100vw, (min-width: 1024px) 476px"
        />
      </div>
      <div className="absolute inset-0 block h-full bg-black/80" />
    </>
  )
}
